import React, { Fragment } from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';

const CountriesList = () => {
  const countries =window.__litium.countriesList;

  return (
    <Fragment>
      {countries && countries.length > 0 && (
        <details>
          <summary>{translate('header.changecountry')}</summary>
          <div className="header__changecountry--countries">
            {countries.map((country, index) => {
              return (
                <a
                  key={'countries-a' + index}
                  href={country.countryURL}
                  title={country.countryName}
                >
                  {country.countryName}
                </a>
              );
            })}
          </div>
        </details>
      )}
    </Fragment>
  );
};

export default CountriesList;
